import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cancel", "submit", "input", "fileInput", "requiredSelect"]

  cancel() {
    this.cancelTarget.click()
  }

  submit() {
    this.element.requestSubmit()
  }

  select(event) {
    event.target.select()
  }

  openFileInput() {
    if (this.hasRequiredSelectTarget && !this.requiredSelectTarget.value) {
      this.requiredSelectTarget.focus()
      return
    }
    if (this.hasFileInputTarget) {
      this.fileInputTarget.click()
    }
  }

  reset() {
    this.element.reset()
  }

  preventEmptySubmit(event) {
    const input = this.hasInputTarget ? this.inputTarget : null

    if (input) {
      const isEmpty = input.value.trim().length === 0

      if (isEmpty) {
        event.preventDefault()
        input.setCustomValidity(input.dataset.validationMessage || "Please fill out this field")
        input.reportValidity()
        input.addEventListener("input", () => input.setCustomValidity(""), { once: true })
      }
    }
  }

  disableSubmitWhenInvalid() {
    if (this.hasSubmitTarget) {
      if (this.element.checkValidity()) {
        this.submitTarget.removeAttribute("disabled")
      } else {
        this.submitTarget.toggleAttribute("disabled", true)
      }
    }
  }
}
